import changeNumber from './change-number.js';
import makeDefault from './make-default.js';
import softDelete from './soft-delete';


export default {
  changeNumber,
  makeDefault,
  softDelete,
};
